import React from "react";
import { createBrowserRouter } from "react-router-dom";
import { App } from "@/components/App/App";
import MainPage from "@/pages/main/MainPage";
import InstallV2RayTunPage from "@/pages/open-vpn/OpenVpnPage";
import { EmailAuthScreen } from "@/features/auth/EmailAuthScreen/EmailAuthScreen";
import { EmailConfirm } from "@/features/auth/EmailConfirm/EmailConfirm";

const routes = [
  {
    element: <App />,
    children: [
      {
        path: "/",
        element: <MainPage />,
      },
      {
        path: "/install-v2raytun",
        element: <InstallV2RayTunPage />,
      },

      { path: "/auth", element: <EmailAuthScreen /> },
      { path: "/confirm-email", element: <EmailConfirm /> },
    ],
  },
];

export const router = createBrowserRouter(routes);
